import { render, staticRenderFns } from "./addnamelist.vue?vue&type=template&id=363abcac"
import script from "./addnamelist.vue?vue&type=script&lang=js"
export * from "./addnamelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports